import { Component } from '@angular/core';

import { PopUpService } from '../insight/pop-up.service';
import { User } from '../user/user.model';

import { createTab } from './human-insight.model';

@Component({
    selector: '[cmpsHumanInsightWizard]',
    templateUrl: './wizard.hi.component.html',
})
export class WizardHumanInsightComponent {
    constructor(private readonly _popUpService: PopUpService) {}

    /** @private */
    _onSelect(user: User): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._popUpService.active &&
            this._popUpService.active.close(createTab(user));
    }
}
